// extracted by mini-css-extract-plugin
export default {"item":"SwipeableListItem_item__7NoLt","bouncing":"SwipeableListItem_bouncing__cxbeX","background":"SwipeableListItem_background__Pazqb","wrapper":"SwipeableListItem_wrapper__b6MU4"};